import { indexItems } from '@/mocks/home';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 border-primary-200',
  accent: 'bg-accent-100 text-accent-700 border-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 border-secondary-200',
};

const iconBgMap: Record<string, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              专题合集
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
              按主题分类浏览，快速找到你感兴趣的瓜
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {indexItems.map((item, i) => (
              <a
                key={i}
                href="#"
                className="group flex flex-col p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className={`w-11 h-11 flex items-center justify-center rounded-lg ${iconBgMap[item.color]} text-background-50 mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3 flex-grow">
                  {item.desc}
                </p>
                <span className={`inline-block text-xs px-2.5 py-1 rounded-full border ${colorMap[item.color]} whitespace-nowrap`}>
                  {item.count}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}